import * as React from "react";
import { Route } from "react-router-dom";
import { CreateDiscount } from "./discount/DiscountCreate";
import { DiscountCreateGrouply } from "./discount/DiscountCreateGrouply";
import { DiscountEdit } from "./discount/DiscountEdit";
import { CampaignCreate } from "./campaign-price/CampaignCreate";
import { CampaignEdit } from "./campaign-price/CampaignEdit";
import { BundleCreate } from "./Bundle/BundleCreate";
import { BundleEdit } from "./Bundle/BundleEdit";
import { CancelSnappPayment } from "./snapp-payment/CancelSnappPayment";
import { UpdateSnappPayment } from "./snapp-payment/UpdateSnappPayment";
import { UpdatePaymentGatewayManager } from "./PaymentGatewayManager/UpdatePaymentGatewayManager";
import { CreatePaymentGatewayManager } from "./PaymentGatewayManager/CreatePaymentGatewayManager";
import { LimoocardAssign } from "./Limoocard/LimoocardAssign";
import { ShowSellerInfo } from "./Limoocard/ShowSellerInfo";
import { SubmitTransaction } from "./Limoocard/SubmitTransaction";
import { EditLimooCard } from './Limoocard/EditLimooCard';
import { CreateReseller } from "./manage-reseller/create-reseller";
import { UpdateResellerWallet } from "./manage-reseller/update-reseller-wallet";
import { NewBetterMeCampaignPopups } from "./newbetterme-campaign-popups";

export default [
  <Route exact path="/create-discount" component={CreateDiscount} />,
  <Route
    exact
    path="/create-discount-grouply"
    component={DiscountCreateGrouply}
  />,
  <Route exact path="/edit-discount" component={DiscountEdit} />,
  <Route exact path="/create-campaign" component={CampaignCreate} />,
  <Route exact path="/edit-campaign" component={CampaignEdit} />,
  <Route exact path="/create-bundle" component={BundleCreate} />,
  <Route exact path="/edit-bundle" component={BundleEdit} />,
  <Route exact path="/snapp-payment/cancel" component={CancelSnappPayment} />,
  <Route
    exact
    path="/payment-gateway-manager/update"
    component={UpdatePaymentGatewayManager}
  />,
  <Route
    exact
    path="/payment-gateway-manager/create"
    component={CreatePaymentGatewayManager}
  />,
  <Route exact path="/snapp-payment/update" component={UpdateSnappPayment} />,
  <Route exact path="/limoocard/assign-seller" component={LimoocardAssign} />,
  <Route
    exact
    path="/limoocard/submit-seller-transaction"
    component={SubmitTransaction}
  />,
  <Route exact path="/limoocard/show-seller-info" component={ShowSellerInfo} />,
  <Route exact path="/limoocard/edit-limoo-card" component={EditLimooCard} />,
  <Route path="/create-reseller" component={CreateReseller} />,
  <Route path="/update-reseller-wallet" component={UpdateResellerWallet} />,
  <Route
    exact
    path="/marketing/newbetterme-campaign-popups"
    component={NewBetterMeCampaignPopups}
  />
];
